import { render } from "./SingleService.vue?vue&type=template&id=cd9c3526"
import script from "./SingleService.vue?vue&type=script&lang=js"
export * from "./SingleService.vue?vue&type=script&lang=js"

import "./SingleService.vue?vue&type=style&index=0&id=cd9c3526&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__